module.exports = __webpack_public_path__ + "img/followupboss.93e2657c.svg";